var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"loading":_vm.loading,"outlined":"","elevation":"0"}},[_c('v-card-title',[_vm._v("Top 5 Incidents")]),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.sources,"disable-pagination":"","hide-default-footer":"","disable-filtering":""},scopedSlots:_vm._u([{key:"item.name",fn:function({ item }){return [_c('router-link',{attrs:{"to":{
        name: 'SourceDetail',
        params: { name: item.name, tab: 'details' },
      }}},[_c('b',[_vm._v(_vm._s(item.name))])])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }